import React, { Component } from 'react';

export default class LowerThird extends Component {
  state = {};

  shouldComponentUpdate(nextProps, nextState) {
    return (this.props.visible !== nextProps.visible)
      || this.state.hover !== nextState.hover;
  }

  render() {
    const {visible} = this.props;
    const LOWER_THIRD_HEIGHT = 50;
    return (<div
      style={{
        position: 'absolute',
        width: '100%',
        height: (visible ? LOWER_THIRD_HEIGHT : 0) + 'px',
        background: 'rgba(0,0,0, 0.4)',
        transition: 'height 0.15s ease-in-out',
        overflow: !this.state.hover && 'hidden',
        bottom: 0,
        ...this.props.style
      }}
      onMouseEnter={() => {this.setState({hover: true}); if (this.props.onMouseLeave) this.props.onMouseEnter();}}
      onMouseLeave={() => {this.setState({hover: false}); if (this.props.onMouseLeave) this.props.onMouseLeave();}}
    >
      {this.props.children}
    </div>);
  }
}
